export enum ContactStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
}
